import React from "react";

export default function ReciveText({ message, recipient, time }) {
    
    return (
        <>  
            <p className="sender"> {recipient} </p>
            <p className="message_context"> 
                <span className="time">{ time }</span>
                <span className="message">
                    {message} 
                </span> 
            </p> 
        </>
    )
}